import { FilterContext } from "components/filters/FilterContext";
import ArtistFilter from "components/filters/Filters/ArtistFilter";
import ContactFilter from "components/filters/Filters/ContactFilter";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import PeriodFilter from "components/filters/Filters/PeriodFilter";
import { PlanningContext } from "PlanningContext/PlanningContext";
import React, { useContext, useEffect } from "react";

const Filters = () => {
  const filterContext = useContext(FilterContext);
  const planningContext = useContext(PlanningContext);

  const artist = filterContext.getValue("artist");
  const period = filterContext.getValue("period");

  useEffect(() => {
    planningContext.setOpts({
      artist: artist.selectedArtists.length > 0 ? artist.selectedArtists[0] : undefined,
      date: period.period === "perDay" ? period.selectionStart : null
    });
  }, [artist, period]);

  return <>
    <KeywordFilter
      title={RESX.GeneralLabels.Search}
      placeholder={RESX.Flight.FlightNumber}
    />
    <ArtistFilter />
    <ContactFilter />
    <PeriodFilter />
  </>;
};

export default Filters;